<script lang="ts">
    export let rankingPercent: number | null | undefined;

    let color: { background: string; text: string };

    function getColors(rankingPercent: number | null | undefined): {
        background: string;
        text: string;
    } {
        let defaultColor = {
            background: '#cccccc',
            text: 'black',
        };
        if (rankingPercent === undefined) return defaultColor;
        if (rankingPercent === null) return defaultColor;
        if (rankingPercent >= 90) {
            return {
                background: '#91cc75',
                text: 'black',
            };
        }
        if (rankingPercent <= 10) {
            return {
                background: '#d93b4d',
                text: 'white',
            };
        }
        return defaultColor;
    }

    $: color = getColors(rankingPercent);
</script>

<div
    style="display: flex; align-items: center; justify-content: center; border: 0; background-color: {color.background}; width: 50px; height: 18px; border-radius: 3px;"
>
    {#if rankingPercent === null || rankingPercent === undefined}
        <div style="color: {color.text};">---</div>
    {:else}
        <div style="color: {color.text}; font-weight: 500;">{rankingPercent}%</div>
    {/if}
</div>
